import { useCallback, useRef } from 'react';
import type { AssistantTargetKey } from './assistantTargetKeys';
import { useOptionalAssistantUi } from './assistantUiContext';

export function useAssistantTarget(
  targetKey: AssistantTargetKey,
  entityId: string | null = null
): (element: HTMLElement | null) => void {
  const assistantUi = useOptionalAssistantUi();
  const registry = assistantUi === null ? null : assistantUi.registry;
  const unregisterRef = useRef<(() => void) | null>(null);
  return useCallback(
    function attachTarget(element: HTMLElement | null) {
      if (unregisterRef.current !== null) {
        unregisterRef.current();
        unregisterRef.current = null;
      }
      if (element === null || registry === null) {
        return;
      }
      unregisterRef.current = registry.register(targetKey, entityId, element);
    },
    [registry, targetKey, entityId]
  );
}
